import { css } from 'styled-components'

export const screenLessThan930 = (...args) => css`
  @media only screen and (max-width: 929px) {
    ${css(...args)};
  }
`
export const screenMoreThan930 = (...args) => css`
  @media only screen and (min-width: 930px) {
    ${css(...args)};
  }
`



// WEBPACK FOOTER //
// ./components/media.js